import React from "react";

const Contact = () => {
    return (
        <section id="contact" className="bg-light py-5">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-md-8 col-lg-6 text-center">
                        <h2 className="h3 mb-4">Kontakt</h2>
                        <p>📞 0176 12345678</p>
                        <p>📧 info@lotusbluete.de</p>
                        <p>📍 Musterstraße 1, 12345 Musterstadt</p>
                        <a href="mailto:info@lotusbluete.de" className="btn contact-btn mt-3">
                            <i className="fas fa-paper-plane me-1"></i> Nachricht senden
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}


export default Contact;


// WEBPACK FOOTER //
// ./src/components/Contact.js